/** Default auto-refresh interval in ms */
export const REFRESH_INTERVAL = 10_000;

/** Timeout options in minutes for offline detection */
export const TIMEOUT_OPTIONS = [15, 30, 60, 120, 240, 480, 720, 1440] as const;

/** Default offline threshold in minutes */
export const DEFAULT_TIMEOUT_INDEX = 0;

/** Default temperature thresholds */
export const DEFAULT_CORE_TEMP_THRESHOLD = 85;
export const DEFAULT_MEMORY_TEMP_THRESHOLD = 95;

/** Temperature warning offset (warn = critical - this) */
export const TEMP_WARN_OFFSET = 10;

/** Navigation sections */
export const SECTIONS = [
  { id: 'overview', label: 'Обзор', icon: 'LayoutDashboard' },
  { id: 'rates', label: 'Курсы', icon: 'TrendingUp' },
  { id: 'spot', label: 'Спот', icon: 'Coins' },
  { id: 'earnings', label: 'Доход', icon: 'DollarSign' },
  { id: 'payments', label: 'Выплаты', icon: 'CreditCard' },
  { id: 'settings', label: 'Настройки', icon: 'Settings' },
] as const;

export type SectionId = typeof SECTIONS[number]['id'];

/** Default electricity rate ₽/kWh */
export const DEFAULT_ELECTRICITY_RATE = 5.5;


/** Rates sort options */
export type RatesSortKey = 'name' | 'price' | 'change' | 'mcap';
export type RatesSortDir = 'asc' | 'desc';

/** Rates filter */
export type RatesFilter = 'all' | 'rising' | 'falling';
